import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import Settings from './Settings';
import {IconFitToMax,IconFlipHorizontal, IconFlipVertical,IconCrop, IconCenter, IconRotateRight} from './Icons';


@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class TransformsBody extends Component{

  @observable trans = {

  };

  @observable activesIcons = [false,false,false,false,false,false,false];

  iconsArray = [];

  constructor(props) {
    super(props);
    this.trans = this.props.dictionaryStorage.getCurrentLangDict;
    let scope = this;

    this.iconsArray['IconFitToMax'] = IconFitToMax;
    this.iconsArray['IconFlipHorizontal'] = IconFlipHorizontal;
    this.iconsArray['IconFlipVertical'] = IconFlipVertical;
    this.iconsArray['IconCrop'] = IconCrop;
    this.iconsArray['IconCenter'] = IconCenter;
    this.iconsArray['IconRotateRight'] = IconRotateRight;

  }

  onClickTransform(transform,e) {
    if ($(e.target).hasClass('disable-area')) {
      return false;
    }
    $(window).trigger('bf-transform', transform.name);
  }

  @action activesIconsDo(key,val){
    this.activesIcons[key] = val;
  }

  render() {



    const data = toJS(this.toolbarData);
    const t = this.t;

    const transforms = [
      {name:'fit-to-max',icon:'IconFitToMax',text:t('Fit to max')},
      {name:'center',icon:'IconCenter',text:t('Center')},
      {name:'crop-image',icon:'IconCrop',text:t('Crop image')},
      {name:'flip-vert',icon:'IconFlipVertical',text:t('Filp vert')},
      {name:'flip-horiz',icon:'IconFlipHorizontal',text:t('Filp horiz')},
      {name:'rotate90',icon:'IconRotateRight',text:t('Rotate 90')},
    ];
    let count = 0;

    return (
        <div className={"TransformsBody  js-tools-on-off-content "}>
          <div className="TransformsBody-prevent"></div>
          <ul className={(this.props.listMode ? 'TransformsBody-listMode ' : 'bf-transform ')}>
            {
              _.map(transforms, (transform, key) => {

                let Icon = this.iconsArray[transform.icon];

                return (
                  <li className="Transforms-li" key={key} >
                    {
                      ( Settings.getSettingsIsActive && !Settings.getSettingsIsActiveImage && transform.name == 'crop-image' )
                      &&
                      <div className="UniversalPrevent"></div>
                    }
                    <span onMouseEnter={()=>{ this.activesIconsDo(key,true) }} onMouseLeave={()=>{this.activesIconsDo(key,false)}} onClick={ (e)=> { this.onClickTransform(transform,e) }} className={ (this.props.listMode ? '' : 'bf-button ') } data-option={transform.name}>
                    <Icon hover={this.activesIcons[key]} />{transform.text}
                    </span>
                  </li>
                )
              })
            }
        </ul>
     </div>

    );
  }
}


